(function ($) {
  "use strict";
  $(function () {

    objectFitImages();

    function toggleMenu(){
      $( "body" ).toggleClass('menu-opened');
    }
    function closeMenu(){
      $( "body" ).removeClass('menu-opened');
    }
  
    $('.header-menu-toggler').click(function() {
      toggleMenu();
    });

    $('#header-menu .nav-link').click(function() {
      closeMenu();
    });

    // HEADER MENU SCROLL ACTIONS
    const nav = $('#header-menu');
    var lastScrollTop = 0;
    $(window).scroll(function () {
        if ($(window).scrollTop() > 110) {
            nav.addClass('scrolled');
        } else {
            nav.removeClass('scrolled');
        }

        var st = $(this).scrollTop();
        if (st <= lastScrollTop) {
            $('#header-menu').addClass('show');
        } else {
            $('#header-menu').removeClass('show');
        }
        lastScrollTop = st;
    });



    $('#competitors-slick-js').slick({
      infinite: false,
      slidesToShow: 4,
      slidesToScroll: 1,
      prevArrow: '#competitors-slick-prev-js',
      nextArrow: '#competitors-slick-next-js',
      responsive: [
        {
          breakpoint: 992,
          settings: {
            slidesToShow: 3,
          }
        },
        {
          breakpoint: 768,
          settings: {
            slidesToShow: 2,
          }
        },
        {
          breakpoint: 575,
          settings: {
            slidesToShow: 1,
          }
        }
      ]
    });


    $.get_episodes_by_season = function get_episodes_by_season(season, count){
      $.ajax({
        url: localize.ajaxurl,
        type: "POST",
        data: {
          season,
          count,
          action: "ajax_load_episodes_by_season"
        },
        error: function(response) {
          console.log(response);
        },
        success: function(response) {
          $(".js-episode-container").html(response);
        }
      });
  
    };

    $.get_extras_by_season = function get_extras_by_season(season, count){
      $.ajax({
        url: localize.ajaxurl,
        type: "POST",
        data: {
          season,
          count,
          action: "ajax_load_extras_by_season"
        },
        error: function(response) {
          console.log(response);
        },
        success: function(response) {
          $(".js-extra-container").html(response);
        }
      });
  
    }

    $.get_competitors_by_season = function get_competitors_by_season(season, count){
      $.ajax({
        url: localize.ajaxurl,
        type: "POST",
        data: {
          season,
          count,
          action: "ajax_load_competitors_by_season"
        },
        error: function(response) {
          console.log(response);
        },
        success: function(response) {
          $('#competitors-slick-js').slick('unslick');
          $(".js-person-container").html(response).promise().done(function(){
     
            $('#competitors-slick-js').slick({
              infinite: false,
              slidesToShow: 4,
              slidesToScroll: 1,
              prevArrow: '#competitors-slick-prev-js',
              nextArrow: '#competitors-slick-next-js',
              responsive: [
                {
                  breakpoint: 992,
                  settings: {
                    slidesToShow: 3,
                  }
                },
                {
                  breakpoint: 768,
                  settings: {
                    slidesToShow: 2,
                  }
                },
                {
                  breakpoint: 575,
                  settings: {
                    slidesToShow: 1,
                  }
                }
              ]
            });
          });

        }
      });
  
    }

    $.get_recepies_by_season = function get_recepies_by_season(season, count){
      $.ajax({
        url: localize.ajaxurl,
        type: "POST",
        data: {
          season,
          count,
          action: "ajax_load_recepies_by_season"
        },
        error: function(response) {
          console.log(response);
        },
        success: function(response) {
          $(".js-recepie-container").html(response);
        }
      });
  
    }
    
    $('#season-select-js--current').click(function (){
      $('#season-select-js').toggleClass('open');
    });

    $('#js-season-select').on('change', function(){
      const season = $(this).val();
      $.get_episodes_by_season(season, 2)
      $.get_extras_by_season(season, 3)
      $.get_competitors_by_season(season, -1, )
      $.get_recepies_by_season(season, 3)
    })

    if(localize.is_frontpage){
      $('#header-menu a.nav-link[href*="#"]').click(function(e){
        e.preventDefault();
        $('html, body').animate({
          scrollTop: $(this.hash).offset().top
        }, 800);
      });
    }


    if ($(".iframe-modal").length) {
      $(".iframe-modal").iziModal({
          history: false,
          iframe: true,
          fullscreen: true,
          headerColor: '#000000',
          openFullscreen: false,
          focusInput: false,
          appendTo: '.modals-wrapper',
          onOpening: function () {
              $('.iframe-modal').find('iframe').attr('allowfullscreen', 'allowfullscreen');
          }
      });
    }

    $.ajax({
      url: localize.ajaxurl,
      type: "POST",
      data: {
        action: "get_latest_instagram_posts"
      },
      error: function(response) {
        console.log(response);
      },
      success: function(response) {
        $("#frontpage-load-instagram-js").html(response);
      }
    });
  

  });
})(jQuery);
